import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@breathelife/mui';
import Typography from '../../../../Components/Typography';
import styled from '../../../../Styles/themed-styled-components';
import { useCarrierContext } from '../../../../Hooks';

export const Link = styled.a`
  color: ${(props) => props.theme.colors.blue[60]};
`;

export function CookieMessage(): ReactElement | null {
  const { t } = useTranslation();
  const { features } = useCarrierContext();
  const cookieConsent = features.cookieConsent;

  if (!cookieConsent.enabled) return null;

  return (
    <Box mb={3}>
      <Box mb={2}>
        <Typography variant='h3' component='h3' grey={90}>
          {t('modals.cookieConsent.profileTitle')}
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant='body1'>{t('modals.cookieConsent.body')}</Typography>
      </Box>
      <Box mb={2}>
        <Link href={t('modals.cookieConsent.linkUrl')} target='_blank' rel='noopener noreferrer'>
          {t('modals.cookieConsent.linkText')}
        </Link>
      </Box>
    </Box>
  );
}
